export default "__VITE_ASSET__f7b7ab55__"